/* ============================================
   記事内の目次アンカー復元
   amanogawa / Empire 12.0.0

   Shopifyの記事エディタは <h2> の id 属性を保存時に削除する。
   （class や href は残るため、目次側は無傷で id だけが消える）
   そのため、目次のリンク文字列と見出しの文字列を突き合わせて、
   ページ読み込み時に id を付け直す。

   assets/toc-anchors.js として保存し、theme.liquid から読み込む。
   ============================================ */
(function () {
  'use strict';

  function normalize(s) {
    // 全角スペース・連続空白・前後の空白を吸収して比較する
    return (s || '').replace(/　/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function restoreAnchors() {
    var toc = document.querySelector('.post-toc');
    if (!toc) return;

    var content = document.querySelector('.article--content');
    if (!content) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3'));
    var links = Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]'));

    links.forEach(function (link, index) {
      var target = link.getAttribute('href').slice(1);
      if (!target || document.getElementById(target)) return;

      var label = normalize(link.textContent);

      // 1. 見出しの文字列が一致するものを探す
      var match = null;
      for (var i = 0; i < headings.length; i++) {
        if (!headings[i].id && normalize(headings[i].textContent) === label) {
          match = headings[i];
          break;
        }
      }

      // 2. 一致しなければ、目次の並び順で対応する見出しにフォールバック
      if (!match && headings[index] && !headings[index].id) {
        match = headings[index];
      }

      if (match) match.id = target;
    });

    // 直接 #アンカー付きのURLで開かれた場合、
    // id を付ける前にブラウザのスクロールが済んでいるので、ここで飛ばし直す
    if (window.location.hash) {
      var el = document.getElementById(window.location.hash.slice(1));
      if (el) el.scrollIntoView();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreAnchors);
  } else {
    restoreAnchors();
  }
})();
